module.exports = __webpack_public_path__ + "static/img/13.d5f4572.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/eng/13.png
// module id = cx29
// module chunks = 0